/** Helper constant representing a null UUID */
const NULL_UUID = '00000000-0000-0000-0000-000000000000';

/**
 * Check if an ID is present and not a null UUID.
 * This does not validate the format of the ID, only that it exists and is not the placeholder null UUID.
 *
 * @param id the ID to check (e.g. assetImageId, assetVideoId, assetFileId)
 * @returns true if the ID is present and not null UUID, false otherwise
 */
export function isNonNullId(id: string | undefined | null): boolean {
    if (!id || typeof id !== 'string') {
        return false;
    }
    if (id === NULL_UUID) {
        return false;
    }
    return true;
}
